import styles from './style.postcss';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import is from 'is_js';
import { testClass } from 'omni-common-ui';

const NoContentMessage = (props) => {
  const noContentMessageClass = classnames(styles.NoContentMessage,
    testClass('no-content-message'));
  const className = is.existy(props.className) ?
    classnames(noContentMessageClass, props.className) :
    noContentMessageClass;
  return <div className={className}>
    {props.text}
  </div>;
};

NoContentMessage.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default NoContentMessage;



// WEBPACK FOOTER //
// ./components/NoContentMessage/index.jsx